import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    Popconfirm,
    Card,
    ProTableOt,
    Form,
    useProTableOt,
    setParamsFilter,
    Tag
} from "../../ui/ot";
// import { useQuestionAndAnswer } from "../controller/question_and_answer_controller";
import SubfieldStructureManagementForm from "./subfield_structure_management_form";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { useSearchParams, useNavigate } from "react-router-dom";


const SubfieldStructureManagementTable = ({
    rowKey = "tagsubfield",
    keyPrefix = "cataloging.subfield_structure_management",
    showAllColumns = true,
    propsShowColumns,
    propsFrameworkcode,
    propsTagfield,
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }, //selectInfo
    permission_level = null, 
}) => {
    const navigate = useNavigate()
    const [frameworkcode, setFrameworkcode] = useState(propsFrameworkcode || '');
    const [tagfield, setTagfield] = useState(propsTagfield || '');

    const { t } = useTranslation('translation', { keyPrefix })

    const columns = [
        {
            title: t("tagsubfield"),
            key: "tagsubfield",
            dataIndex: "tagsubfield",
            align: "center",
        },
        {
            title: t("liblibrarian"),
            key: "liblibrarian",
            dataIndex: "liblibrarian",
            align: "center",
        },
        {
            title: t("libopac"),
            key: "libopac",
            dataIndex: "libopac",
            align: "center",
        },
        {
            title: t("repeatable"),
            key: "repeatable",
            dataIndex: "repeatable",
            align: "center",
            render: (text, record, index) => {
                if (parseInt(text) === 1) {
                    return <Row justify="center">
                        <Col>
                            <Tag color="success">
                                {t('yes')}
                            </Tag>
                        </Col>
                    </Row>
                }
                else {
                    return <Row justify="center">
                        <Col>
                            <Tag color="cyan-inverse">
                                {t('no')}
                            </Tag>
                        </Col>
                    </Row>
                }
            }
        },
        {
            title: t("mandatory"),
            key: "mandatory",
            dataIndex: "mandatory",
            align: "center",
            render: (text, record, index) => {
                if (parseInt(text) === 1) {
                    return <Row justify="center">
                        <Col>
                            <Tag color="success">
                                {t('yes')}
                            </Tag>
                        </Col>
                    </Row>
                }
                else {
                    return <Row justify="center">
                        <Col>
                            <Tag color="cyan-inverse">
                                {t('no')}
                            </Tag>
                        </Col>
                    </Row>
                }
            }
        },
        {
            title: t("important"),
            key: "important",
            dataIndex: "important",
            align: "center",
            render: (text, record, index) => {
                if (parseInt(text) === 1) {
                    return <Row justify="center">
                        <Col>
                            <Tag color="success">
                                {t('yes')}
                            </Tag>
                        </Col>
                    </Row>
                }
                else {
                    return <Row justify="center">
                        <Col>
                            <Tag color="cyan-inverse">
                                {t('no')}
                            </Tag>
                        </Col>
                    </Row>
                }
            }
        },
        {
            title: t("kohafield"),
            key: "kohafield",
            dataIndex: "kohafield",
            align: "center",
        },
        {
            title: t("tab"),
            key: "tab",
            dataIndex: "tab",
            align: "center",
        },
        {
            title: t("authorised_value"),
            key: "authorised_value",
            dataIndex: "authorised_value",
            align: "center",
        },
        {
            title: t("authtypecode"),
            key: "authtypecode",
            dataIndex: "authtypecode",
            align: "center",
        },
        {
            title: t("value_builder"),
            key: "value_builder",
            dataIndex: "value_builder",
            align: "center",

        },
        {
            title: t("isurl"),
            key: "isurl",
            dataIndex: "isurl",
            align: "center",

            render: (text, record, index) => {
                if (parseInt(text) === 1) {
                    return <Row justify="center">
                        <Col>
                            <Tag color="success">
                                {t('yes')}
                            </Tag>
                        </Col>
                    </Row>
                }
                else {
                    return <Row justify="center">
                        <Col>
                            <Tag color="cyan-inverse">
                                {t('no')}
                            </Tag>
                        </Col>
                    </Row>
                }
            }
        },
        {
            title: t("seealso"),
            key: "seealso",
            dataIndex: "seealso",
            align: "center",
        },
        {
            title: t("LINK"),
            key: "LINK",
            dataIndex: "LINK",
            align: "center",
        },
        {
            title: t("defaultvalue"),
            key: "defaultvalue",
            dataIndex: "defaultvalue",
            align: "center",
        },
        {
            title: t("maxlength"),
            key: "maxlength",
            dataIndex: "maxlength",
            align: "center",
        },
        {
            title: t("display_order"),
            key: "display_order",
            dataIndex: "display_order",
            align: "center",
        },
        {
            title: t("hidden_opac"),
            key: "hidden_opac",
            dataIndex: "hidden_opac",
            align: "center",
            render: (text, record, index) => {
                if (parseInt(text) === 1) {
                    return <Row justify="center">
                        <Col>
                            <Tag color="success">
                                {t('yes')}
                            </Tag>
                        </Col>
                    </Row>
                }
                else {
                    return <Row justify="center">
                        <Col>
                            <Tag color="cyan-inverse">
                                {t('no')}
                            </Tag>
                        </Col>
                    </Row>
                }
            }
        },
        {
            title: t("hidden_staff_interface"),
            key: "hidden_staff_interface",
            dataIndex: "hidden_staff_interface",
            align: "center",
            render: (text, record, index) => {
                if (parseInt(text) === 1) {
                    return <Row justify="center">
                        <Col>
                            <Tag color="success">
                                {t('yes')}
                            </Tag>
                        </Col>
                    </Row>
                }
                else {
                    return <Row justify="center">
                        <Col>
                            <Tag color="cyan-inverse">
                                {t('no')}
                            </Tag>
                        </Col>
                    </Row>
                }
            }
        },
        {
            title: t("hidden_editor"),
            key: "hidden_editor",
            dataIndex: "hidden_editor",
            align: "center",
            render: (text, record, index) => {
                if (parseInt(text) === 1) {
                    return <Row justify="center">
                        <Col>
                            <Tag color="success">
                                {t('yes')}
                            </Tag>
                        </Col>
                    </Row>
                }
                else {
                    return <Row justify="center">
                        <Col>
                            <Tag color="cyan-inverse">
                                {t('no')}
                            </Tag>
                        </Col>
                    </Row>
                }
            }
        },
        {
            title: t("hidden_collapsed"),
            key: "hidden_collapsed",
            dataIndex: "hidden_collapsed",
            align: "center",
            render: (text, record, index) => {
                if (parseInt(text) === 1) {
                    return <Row justify="center">
                        <Col>
                            <Tag color="success">
                                {t('yes')}
                            </Tag>
                        </Col>
                    </Row>
                }
                else {
                    return <Row justify="center">
                        <Col>
                            <Tag color="cyan-inverse">
                                {t('no')}
                            </Tag>
                        </Col>
                    </Row>
                }
            }
        },
        {
            title: t("hidden_flagged"),
            key: "hidden_flagged",
            dataIndex: "hidden_flagged",
            align: "center",
            render: (text, record, index) => {
                if (parseInt(text) === 1) {
                    return <Row justify="center">
                        <Col>
                            <Tag color="success">
                                {t('yes')}
                            </Tag>
                        </Col>
                    </Row>
                }
                else {
                    return <Row justify="center">
                        <Col>
                            <Tag color="cyan-inverse">
                                {t('no')}
                            </Tag>
                        </Col>
                    </Row>
                }
            }
        },
    ];
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : ['question_and_answer_data', 'title'])

    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record?.[rowKey]);
                selectRow = selectRow.filter((row) => row?.[rowKey] !== record?.[rowKey]);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [form] = Form.useForm();


    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }

    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };


    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    const subfieldStructureManagementController = useCRUDController({
        apiRoute: "/koha/marc/subfieldStructure",
        onFinish,
        onBefore
    })
    useEffect(() => {
        checkAll();

    }, []);
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [frameworkcode, tagfield])
    return (<Row>
        <Col span={24}>
            <ProTableOt
                searchParams={{
                    frameworkcode,
                    tagfield
                }}
                formMode={true}
                actionRef={actionRef}
                headerTitle={
                    <>

                    </>
                }
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={rowKey}

                toolBarRender={() => {
                    return []
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    let newParams = {};
                    let order = setOrders(sort);
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                        frameworkcode,
                        tagfield
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return subfieldStructureManagementController.getData(newParams);
                    // return []
                }}
                pageSize={pageSize}
                rowSelection={
                    {
                        type: rowSelectType,
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }
                }

                propsPatchProcess={(data) => {


                    return {
                        ...data,
                        axiosMode: "patch"
                    }
                }}
                initialValues={{
                    "tagsubfield": "",
                    "tagfield": tagfield,
                    frameworkcode:frameworkcode,
                    "liblibrarian": null,
                    "libopac": "",
                    "repeatable": 0,
                    "mandatory": 0,
                    "important": 0,
                    "kohafield": "",
                    "tab": 0,
                    "authorised_value": "",
                    "authtypecode": "",
                    "value_builder": "",
                    "isurl": null,
                    "seealso": "",
                    "LINK": "",
                    "defaultvalue": null,
                    "maxlength": 9999,
                    "display_order": 0,
                    // "key": 1,
                    "hidden_opac":0,
                    "hidden_staff_interface": 0,
                    "hidden_editor": 0,
                    "hidden_collapsed": 0,
                    "hidden_flagged": 0
                }}
                propsPostOnBefore={(data) => {
                    return {
                        ...data,

                        axiosMode: "post"
                    }
                }}
                propsUseData={() => {
                    return {
                        postData: (formData) => {

                            let postData = formData.map((formValue) => {
                                return {
                                    ...formValue,
                                }

                            })
                            subfieldStructureManagementController.postData(postData)
                        },
                        patchData: (formData) => {
                            let patchData = formData.map((formValue) => {
                                return {
                                    ...formValue,
                                }
                            })
                            subfieldStructureManagementController.patchData(patchData)
                        },
                        deleteData: subfieldStructureManagementController.deleteData
                    }
                }}
                PropsPatchForm={<SubfieldStructureManagementForm />}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                propsPatch={permission_level === 1 ? true : false}
                propsDelete={permission_level === 1 ? true : false}
                propsPost={permission_level === 1 ? true : false}
                propsWidth={800}
                scroll={{
                    x: "100%",
                }}
            />
        </Col>
    </Row>)

}
const SubfieldStructureManagement = ({
    keyPrefix = "cataloging.subfield_structure_management",
    permission_level = null, 
}) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const frameworkcode = searchParams.get('frameworkcode')
    const tagfield = searchParams.get('tagfield')
    return (
        <Row
            gutter={[10, 20]}
        >

            <Col span={24}>
                <SubfieldStructureManagementTable
                    keyPrefix={keyPrefix}
                    propsFrameworkcode={frameworkcode}
                    propsTagfield={tagfield}
                    permission_level={permission_level}
                />
            </Col>
        </Row>
    );
};
export { SubfieldStructureManagementTable }
export default SubfieldStructureManagement;
